import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { styles } from "../../styles/styles.js";
import * as motion from "motion/react-client";
import ReactMarkdown from "react-markdown";
import { LastTen } from "./lastten.js";
import { rate, record } from "../../utils/format.js";

const Overs = ({ fixture }) => {
  const [showPercentages, setShowPercentages] = useState(true);
  // const [isAutoCycling, setIsAutoCycling] = useState(true);

  // useEffect(() => {
  //   let interval;
  //   if (isAutoCycling) {
  //     interval = setInterval(() => {
  //       setShowPercentages(!showPercentages);
  //     }, 10000);
  //   }
  //   return () => clearInterval(interval);
  // }, [isAutoCycling]);
  
  const togglePercentages = () => {
    // setIsAutoCycling(false);
    setShowPercentages(!showPercentages);
  };

  const AnimatedCell = ({ children }) => (
    <motion.div
      key={showPercentages}
      initial={{ opacity: 0, x: -100 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{
        duration: 0.5,
        scale: { type: "spring", damping: 10, stiffness: 100, bounce: 0.5 },
      }}>
      {children}
    </motion.div>
  );

  if (!fixture.recent) return null;

  return (
    <>
      <Table bordered className="main">
        <tbody>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={togglePercentages}>Overs</td>
            <td className="Cells" style={styles.Cells}> </td>
            <td className="Cells" style={styles.Cells}> </td>
          </tr>
          <tr>
            <td className="Cells" style={styles.column_1} onClick={togglePercentages}> </td>
            <td className="Cells" style={styles.column_1}>{fixture.home_team}</td>
            <td className="Cells" style={styles.column_1}>{fixture.away_team}</td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={togglePercentages}>Last 3</td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.recent.home_overs_hit_3, fixture.recent.home_overs_sample_3, 3)
                : record(fixture.recent.home_overs_hit_3, fixture.recent.home_overs_sample_3, 3)}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.recent.away_overs_hit_3, fixture.recent.away_overs_sample_3, 3)
                : record(fixture.recent.away_overs_hit_3, fixture.recent.away_overs_sample_3, 3)}
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={togglePercentages}>Last 5</td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.recent.home_overs_hit_5, fixture.recent.home_overs_sample_5, 5)
                : record(fixture.recent.home_overs_hit_5, fixture.recent.home_overs_sample_5, 5)}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.recent.away_overs_hit_5, fixture.recent.away_overs_sample_5, 5)
                : record(fixture.recent.away_overs_hit_5, fixture.recent.away_overs_sample_5, 5)}
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={togglePercentages}>Last 10</td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.recent.home_overs_hit_10, fixture.recent.home_overs_sample_10, 10)
                : record(fixture.recent.home_overs_hit_10, fixture.recent.home_overs_sample_10, 10)}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.recent.away_overs_hit_10, fixture.recent.away_overs_sample_10, 10)
                : record(fixture.recent.away_overs_hit_10, fixture.recent.away_overs_sample_10, 10)}
              </AnimatedCell>
            </td>
          </tr>
          <tr style={styles.Cells}>
            <td className="Cells" style={styles.column_1} onClick={togglePercentages}>Season</td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.stats?.home_overs_hit, fixture.stats?.home_overs_sample, fixture.stats?.count_home)
                : record(fixture.stats?.home_overs_hit, fixture.stats?.home_overs_sample, fixture.stats?.count_home)}
              </AnimatedCell>
            </td>
            <td className="Cells" style={styles.Cells}>
              <AnimatedCell>
              {showPercentages
                ? rate(fixture.stats?.away_overs_hit, fixture.stats?.away_overs_sample, fixture.stats?.count_away)
                : record(fixture.stats?.away_overs_hit, fixture.stats?.away_overs_sample, fixture.stats?.count_away)}
              </AnimatedCell>
            </td>
          </tr>
          {shouldShowLastSeason(fixture) && (
            <tr style={styles.Cells}>
              <td className="Cells" style={styles.column_1} onClick={togglePercentages}>Last Season</td>
              <td className="Cells" style={styles.Cells}>
                <AnimatedCell>
                {showPercentages
                  ? rate(fixture.stats?.home_overs_hit_last, fixture.stats?.home_overs_sample_last, fixture.stats?.count_home_last)
                  : record(fixture.stats?.home_overs_hit_last, fixture.stats?.home_overs_sample_last, fixture.stats?.count_home_last)}
                </AnimatedCell>
              </td>
              <td className="Cells" style={styles.Cells}>
                <AnimatedCell>
                {showPercentages
                  ? rate(fixture.stats?.away_overs_hit_last, fixture.stats?.away_overs_sample_last, fixture.stats?.count_away_last)
                  : record(fixture.stats?.away_overs_hit_last, fixture.stats?.away_overs_sample_last, fixture.stats?.count_away_last)}
                </AnimatedCell>
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      <LastTen
        results={Array(10)
          .fill()
          .map((_, i) => fixture.recent[`home_${i + 1}_over_hit`])
          .reverse()}
        teamName={fixture.home_team}
        title = {fixture.home_team + ' overs hit'}
      />
      <div style={{ height: '10vh' }}></div>
      <LastTen
        results={Array(10)
          .fill()
          .map((_, i) => fixture.recent[`away_${i + 1}_over_hit`])
          .reverse()}
        teamName={fixture.away_team}
        title = {fixture.away_team + ' overs hit'}
      />

      <div style={{ height: '2vh' }}></div>

      <div style={{ marginTop: '20px' }}>
        { fixture.box_score && fixture.box_score['overs_stats'] && (
          <ul style={{ 
            listStyleType: 'none', 
            padding: 0,
            margin: 0,
            fontSize: 'clamp(10px, calc(7px + (4) * ((100vw - 300px) / (1200 - 320))), 18px)'
          }}>
            <ReactMarkdown>{fixture.box_score['overs_stats']}</ReactMarkdown>
          </ul>
        )}
      </div>
    </>
  );
};

// This function should be moved to a utility file
function shouldShowLastSeason(fixture) {
  if (fixture.league === "NFL") {
    return true;
  }
  // Unknown season progress is not early-season. Showing a "Last Season" row we
  // cannot justify is worse than omitting it, and the old unguarded deref threw.
  return fixture.ratings?.progress != null && fixture.ratings.progress < 0.15;
}

export default Overs;